module.exports = __webpack_public_path__ + "img/cooperate_3.85539590.png";